export const ConnectionType = {
  VISIT: 'visit',
  VISIT_CHECKIN: 'visit_checkin',
  MONITOR: 'monitor'
}

export const Events = {
  ROOM_DISCONNECTED: 'roomDisconnected',
  REMOTE_AUDIO_TRACK_ATTACHED: 'remoteAudioTrackAttached',
  REMOTE_VIDEO_TRACK_ATTACHED: 'remoteVideoTrackAttached',
  NETWORK_QUALITY_CHANGED: 'networkQualityChanged',
  PARTICIPANT_CONNECTED: 'participantConnected',
  PARTICIPANT_DISCONNECTED: 'participantDisconnected',
  REMOTE_CAMERA_ENABLED: 'remoteCameraEnabled'
}

export const TrackType = {
  LOCAL: 'local',
  REMOTE: 'remote'
}

export const Media = {
  AUDIO: 'audio',
  VIDEO: 'video'
}
